interface Props {
  reason: string;
}

export function IncompatibleScreen({ reason }: Props) {
  return (
    <div className="p-6 space-y-4">
      <h1 className="font-serif-title text-xl text-stone-800">Version d'Excel non compatible</h1>
      <p className="text-sm text-stone-600">{reason}</p>
      <p className="text-sm text-stone-600">
        Mets à jour Excel (menu <em>Fichier → Compte → Options de mise à jour</em>) ou utilise Excel 2021 ou plus
        récent.
      </p>
      <a
        className="text-sm text-emerald-700 underline"
        href="https://learn.microsoft.com/fr-fr/javascript/api/requirement-sets/excel/excel-api-requirement-sets"
        target="_blank"
        rel="noreferrer"
      >
        Documentation officielle Microsoft
      </a>
    </div>
  );
}
